import { render, staticRenderFns } from "./PostsList.vue?vue&type=template&id=3acadcf4&"
import script from "./PostsList.vue?vue&type=script&lang=js&"
export * from "./PostsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports